import { combineReducers } from 'redux';
import entriesReducer from '../entries/reducers';

export const rootReducer = () => combineReducers({
    entries: entriesReducer,
});

export default rootReducer;